import { logoutThunk } from '@/store/thunks/auth/logoutThunk';
import { announceFileKeyReadyThunk } from '@/store/thunks/poc/messaging/announceFileKeyReadyThunk';
import { sendFileAnnouncement } from '@/store/thunks/poc/messaging/announceFileReadyThunk';
import {
  cancelAllPendingAckTasks,
  startFileAnnouncementAckTimer,
  startFileKeyAckTimer,
} from '@/store/listeners/poc/pendingAckCoordinator';
import type { AppStartListening } from '@/store/listeners/types';

export function registerPendingAckListeners(startAppListening: AppStartListening): void {
  startAppListening({
    actionCreator: sendFileAnnouncement.fulfilled,
    effect: (action, listenerApi) => {
      const { messageId, attemptCount, sixId, cid } = action.payload;
      const { uploadId, metadata, targetPeerId } = action.meta.arg;

      startFileAnnouncementAckTimer(listenerApi, {
        messageId,
        attemptCount,
        sixId,
        cid,
        uploadId,
        metadata,
        targetPeerId,
      });
    },
  });

  startAppListening({
    actionCreator: announceFileKeyReadyThunk.fulfilled,
    effect: (action, listenerApi) => {
      const { messageId, attemptCount, sixId, fileId, newFileKeyCID } = action.payload;
      const { newFileKeyForUserId, newFileKeyCreatorUserId, metadata } = action.meta.arg;

      startFileKeyAckTimer(listenerApi, {
        messageId,
        attemptCount,
        sixId,
        fileId,
        newFileKeyCID,
        newFileKeyForUserId,
        newFileKeyCreatorUserId,
        metadata,
      });
    },
  });

  startAppListening({
    actionCreator: logoutThunk.pending,
    effect: () => {
      cancelAllPendingAckTasks();
    },
  });
}
